<template>
  <div class="container">
    <div class="calculo-container" style="background:#fff;padding:0px; ">
      <topOp> </topOp>
      <div class="div-titulo">
        <h3 class="titulo">Cálculo de Atestados</h3>
      </div>
      <div class="form-novo-atestado">
      
        <div class="form-inicioAtestado">
          <label for="dataInicio">Data Início do Atestado:</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-calendar" style="color:#808080;"></i>
              </span>
            </div>
            <input
              type="date"
              class="form-control formatacaoInput"
              v-model="novoAtestado.dataInicio"
              placeholder="DD/MM/AAAA"
              maxlength="10"
            />
          </div>
        </div>
        <div class="form-dataRetorno">
          <label for="dataRetorno">Data do Retorno ao Trabalho:</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                 <i class="fa fa-calendar" style="color:#808080;"></i>
              </span>
            </div>
            <input
              type="date"
              class="form-control"
              v-model="novoAtestado.dataRetorno"
              :min="novoAtestado.dataInicio"
            />
          </div>
        </div>
        <div class="form-group" v-if="diasDeAfastamento > 0">
            <label>Total de Dias de Afastamento (calculado):</label>
            <input type="text" class="form-control" :value="diasDeAfastamento" disabled>
        </div>

        <div class="selector-group">
          <label>Pesquisar por:</label>
          <div class="seletor-busca-container">
            <label class="seletor-busca-label">
              <input type="radio" value="categoria" v-model="tipoBusca">
              <span>Código CID</span>
            </label>
            <label class="seletor-busca-label">
              <input type="radio" value="descricao" v-model="tipoBusca">
              <span>Descrição</span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <label for="cid-search">Busca de CID:</label>
          <input
            id="cid-search"
            type="text"
            class="form-control"
            v-model="buscaCid"
            @input="buscarCid"
            :placeholder="placeholderDaBusca"
          />
          <ul v-if="sugestoesCid.length" class="sugestoes-cid">
            <li
              v-for="cid in sugestoesCid"
              :key="cid.categoria"
              @click="selecionarCid(cid)"
            >
              {{ cid.categoria }} - {{ cid.descricao }}
            </li>
          </ul>
        </div>
        
        <button
          class="add-btn"
          @click="adicionarAtestado"
          :disabled="!isFormularioValido"
        >
          Adicionar Atestado
        </button>
      </div>

      <div v-if="atestados.length > 0" class="lista-atestados">
        <h4>Atestados para Cálculo:</h4>
        <ul>
          <li class="lista" v-for="(atestado, index) in atestados" :key="index">
            <span
              >Início: {{ formatarData(atestado.dataInicio) }} |
              {{ atestado.dias }} dias | CID: {{ atestado.cid.categoria }}</span
            >
            <button class="remover" @click="removerAtestado(index)">X</button>
          </li>
        </ul>
        <button class="calcular-btn" @click="realizarCalculo" :disabled="loading">
          <span v-if="loading">Calculando...</span>
          <span v-else>Calcular</span>
        </button>
      </div>

      <div v-if="resultado" class="resultado-calculo" ref="resultadoSection">
        <h4>Resultado</h4>
        <p v-html="resultadoFormatado"></p>
      </div>
    </div>
  </div>
</template>

<script>
import topOp from "../shared/topOp.vue";
import categorias from "../assets/categorias.json";

export default {
  name: "CalculoAtestado",
  components: {
    topOp,
  },
  data() {
    return {
      tipoBusca: 'categoria',
      novoAtestado: {
        dataInicio: "",
        dataRetorno: "",
        cid: null,
      },
      atestados: [],
      resultado: "",
      todosOsCids: [],
      buscaCid: "",
      sugestoesCid: [],
      loading: false,
    };
  },
  computed: {
    diasDeAfastamento() {
      if (!this.novoAtestado.dataInicio || !this.novoAtestado.dataRetorno) {
        return 0;
      }
      const inicio = new Date(this.novoAtestado.dataInicio + 'T00:00:00');
      const retorno = new Date(this.novoAtestado.dataRetorno + 'T00:00:00');

      if (retorno <= inicio) {
        return 0;
      }
      const diffTime = Math.abs(retorno - inicio);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

      return diffDays;
    },
    placeholderDaBusca() {
      if (this.tipoBusca === 'categoria') {
        return 'Digite o código CID';
      } else {
        return 'Digite a descrição da doença';
      }
    },

    isFormularioValido() {
      return (
        this.novoAtestado.dataInicio &&
        this.novoAtestado.dataRetorno &&
        this.diasDeAfastamento > 0 &&
        this.novoAtestado.cid
      );
    },
    resultadoFormatado() {
      return this.resultado.replace(/\n/g, "<br>");
    },
  },
  created() {
    this.carregarCids();
  },
  methods: {
    async carregarCids() {
  this.todosOsCids = categorias;
},
    buscarCid() {
      if (this.buscaCid.length < 2) {
        this.sugestoesCid = [];
        return;
      }

      const termo = this.buscaCid.toLowerCase();
      let resultadosFiltrados = [];

      if (this.tipoBusca === 'categoria') { 
        resultadosFiltrados = this.todosOsCids.filter(
          (cid) => cid.categoria && cid.categoria.toLowerCase().includes(termo)
        );
      } else { 
        resultadosFiltrados = this.todosOsCids.filter(
          (cid) => cid.descricao && cid.descricao.toLowerCase().includes(termo)
        );
      }
      
      this.sugestoesCid = resultadosFiltrados.slice(0, 10);
    },
    selecionarCid(cid) {
      this.novoAtestado.cid = cid;
      this.buscaCid = `${cid.categoria} - ${cid.descricao}`;
      this.sugestoesCid = [];
    },
    adicionarAtestado() {
      if (!this.isFormularioValido) return;

      const atestadoParaAdicionar = {
        dataInicio: this.novoAtestado.dataInicio,
        dataRetorno: this.novoAtestado.dataRetorno,
        cid: this.novoAtestado.cid,
        dias: this.diasDeAfastamento,
      };

      this.atestados.push(atestadoParaAdicionar);

      this.novoAtestado = { dataInicio: "", dataRetorno: "", cid: null };
      this.buscaCid = "";
    },
    removerAtestado(index) {
      this.atestados.splice(index, 1);
    },
    realizarCalculo() {
      this.loading = true;
      setTimeout(() => {
      const cidsAgrupados = this.atestados.reduce((acc, atestado) => {
        const categoria = atestado.cid.categoria;
        if (!acc[categoria]) {
          acc[categoria] = [];
        }
        acc[categoria].push(atestado);
        return acc;
      }, {});

      for (const codigoCid in cidsAgrupados) {
        const grupoAtestados = cidsAgrupados[codigoCid];
        grupoAtestados.sort(
          (a, b) => new Date(a.dataInicio) - new Date(b.dataInicio)
        );

        for (let i = 0; i < grupoAtestados.length; i++) {
          let diasSomados = grupoAtestados[i].dias;
          const dataInicioPeriodo = new Date(grupoAtestados[i].dataInicio);
          for (let j = i + 1; j < grupoAtestados.length; j++) {
            const dataInicioProximo = new Date(grupoAtestados[j].dataInicio);
            const diffEmMs = dataInicioProximo - dataInicioPeriodo;
            const diffEmDias = diffEmMs / (1000 * 60 * 60 * 24);
            if (diffEmDias <= 60) {
              diasSomados += grupoAtestados[j].dias;
            }
          }
          if (diasSomados > 15) {
            this.loading = false;
            this.resultado =
              "Considerando tratar-se de atestado superior a 15 dias, pelo mesmo motivo, o empregado deve ser encaminhado ao INSS";
            this.$nextTick(() => {
              this.$refs.resultadoSection.scrollIntoView({ behavior: "smooth" });
            });
            return;
          }
        }
      }
        this.loading = false;
      this.resultado = `Não serão somados os atestados e a empresa será responsável pelo pagamento de cada atestado nas seguintes situações:\n
a) atestados menores ou de até 15 dias;\n
b) atestados descontínuos por doenças diferentes; e\n 
c) atestados descontínuos pela mesma doença, desde que o intervalo entre eles seja superior a 60 dias.`;
        this.$nextTick(() => {
              this.$refs.resultadoSection.scrollIntoView({ behavior: "smooth" });
            });
            }, 1000);
    },
    formatarData(dataString) {
      if (!dataString) return "";
      const data = new Date(dataString);
      const dataCorrigida = new Date(
        data.valueOf() + data.getTimezoneOffset() * 60 * 1000
      );
      return dataCorrigida.toLocaleDateString("pt-BR");
    },
  },
};
</script>

<style scoped>
.calculo-container {
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.div-titulo {
  padding-left: 110px;
  padding-right: 110px;
  padding-bottom: 45px;
}
.titulo {
  font-style: italic;
  font-weight: 700;
  border-bottom: 1px solid #707070;
  padding-bottom: 15px;
  text-align: left;
  font-size: 26px;
}
.form-novo-atestado {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 350px;
  margin: 0 auto;
}
.form-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 18px;
}

.form-group input,
.form-group .input-group {
  width: 100%;
  max-width: 400px;
  margin-bottom: 5px;
}

.form-group label {  
  text-align: left;
  width: 100%;
}

.form-group input {
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.3s ease;
  max-width: 400px;
  width: 100%;
  box-sizing: border-box;
  /* margin-bottom: 20px; */
}

.form-group input:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}
.add-btn {
  color: #fff;
  background-color: #ff7835;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 30px;
}
.sugestoes-cid {
  list-style: none;
  padding: 0;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  position: relative;
  background: white;
  width: 100%;
  z-index: 10;
}
.sugestoes-cid li {
  padding: 8px;
  cursor: pointer;
}
.sugestoes-cid li:hover {
  background-color: #f0f0f0;
}
.lista-atestados {
  margin-top: 2rem;
}
.lista-atestados h4{
  margin-bottom: 1.5rem;
    text-align: center;
}
.remover {
  margin-left: 1rem;
  color: white;
  border-radius: 6px;
  background: rgb(243, 44, 44);
  border: none;
  cursor: pointer;
}
.calcular-btn {
  background: #ff7835 0% 0% no-repeat padding-box;
  border: 2px solid #ff7835;
  border-radius: 5px;
  width: 170px;
  font-size: 21px;
  height: 48px;
  color: #fff;
  margin-top: 15px;
  font-weight: 600;
  cursor: pointer;
  font-style: italic;
  margin-bottom: 30px;
}
.calcular-btn:hover {
  background: #e64d00;
  border: 1px solid #e64d00;
}
.resultado-calculo {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #e3f2fd;
  border-left: 5px solid #2196f3;
}
.resultado-calculo p {
  display: inline-block;
  text-align: left;
}
input.formatacaoInput {
  border-radius: 10px;
  height: 43px;
}
.seletor-busca-container {
  display: flex;
  /* border: 1px solid #ced4da; */
  border-radius: 0.25rem;
  overflow: hidden;
  margin-bottom: 1rem;
  width: 100%;
}
.seletor-busca-label {
  flex: 1;
  text-align: center;
  margin-bottom: 0;
  border: 1px solid #ced4da;
}
.seletor-busca-label + .seletor-busca-label {
  margin-left: -1px;
}
.seletor-busca-label span {
  display: block;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  background-color: #e9ecef;
  color: #495057;
  transition: background-color 0.2s ease, color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.seletor-busca-label input[type="radio"] {
  display: none;
}
.seletor-busca-label input[type="radio"]:checked + span {
  background-color: #F7B733;
  color: white;
  font-weight: bold;
}
.lista {
    padding: 8px;
    background-color: #ffe9bd;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 350px;
    border-radius: 6px;
    margin-bottom: 15px;
}
ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.selector-group {
    width: 100%;
    text-align: left;
}
.form-inicioAtestado{
    width: 100%;
    max-width: 400px;
    margin-bottom: 20px;
    text-align: left;
}
.form-dataRetorno {
    width: 100%;
    max-width: 400px;
    margin-bottom: 20px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/screens/CalculoAtestado.vue